<div *ngIf="isLive" class="navigation-bar">
  <span
    (click)="selectTab('effects')"
    [class.active]="selectedTab === 'effects'"
  >
    Effects
  </span>
  <span
    (click)="selectTab('videoClips')"
    [class.active]="selectedTab === 'videoClips'"
  >
    video clips
  </span>
  <!--<span
    (click)="false && selectTab('graphics')"
    [class.active]="selectedTab === 'graphics'"
    style="cursor: not-allowed"
  >
    graphics
  </span>
  <span
    (click)="false && selectTab('edl')"
    [class.active]="selectedTab === 'edl'"
    style="cursor: not-allowed"
  >
    edl
  </span>-->
</div>
<ng-container *ngTemplateOutlet="selectedTabBody"></ng-container>
<ng-template #effectsBody>
  <div class="container" #hideObject>
    <div class="container-head">
      <svg
        class="more-arrow"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.86">
          <path
            d="M5.76953 14.5701L11.7695 8.57007L5.76953 2.57007L5.76953 14.5701Z"
            fill="black"
            fill-opacity="0.54"
          />
        </g>
      </svg>
      <span>hide object</span>
      <div class="buttons">
        <div class="row" [class.disallow]="disableEverything">
          <evrideo-content-control-studio-action-button
            (buttonClicked)="!disableEverything && toggleShowHideObjectMenu()"
            style="width: 50px; height: 50px; background-color: #ebf0f4"
            title="hide object menu"
          >
            <img
              width="28px"
              height="28px"
              src="/assets/ccstudio/hide-object.svg"
            />
          </evrideo-content-control-studio-action-button>
        </div>
      </div>
    </div>
    <div class="container-body hide-object-menu">
      <mat-form-field appearance="outline">
        <mat-label>Effect type</mat-label>
        <mat-select
          [value]="selectedVideoEffect"
          (selectionChange)="onVideoEffectChange($event)"
          placeholder="Select an effect"
        >
          <mat-optgroup label="Rectangles">
            <mat-option *ngFor="let ve of videoEffects[0]" [value]="ve">{{
              ve.displayName
            }}</mat-option>
          </mat-optgroup>
          <mat-optgroup label="Circles">
            <mat-option *ngFor="let ve of videoEffects[1]" [value]="ve">{{
              ve.displayName
            }}</mat-option>
          </mat-optgroup>
          <mat-optgroup label="Screen">
            <mat-option *ngFor="let ve of videoEffects[2]" [value]="ve">{{
              ve.displayName
            }}</mat-option>
          </mat-optgroup>
        </mat-select>
      </mat-form-field>
      <div *ngIf="selectedSegment" class="adjustments">
        <div
          *ngIf="
            selectedVideoEffect?.type == CCAction.BlurOval ||
            selectedVideoEffect?.type == CCAction.BlurScreen ||
            selectedVideoEffect?.type == CCAction.BlurRect
          "
        >
          <div class="slider-label-container">
            <label class="slider-name-label">Radius</label>
            <label class="slider-value-label">{{
              selectedSegment?.instructions?.sampleDistance
            }}</label>
          </div>
          <mat-slider min="1" max="15" step="1" discrete>
            <input
              (valueChange)="onSampleDistanceChange($event)"
              matSliderThumb
              [value]="selectedSegment?.instructions?.sampleDistance"
            />
          </mat-slider>
        </div>
        <div
          *ngIf="
            selectedVideoEffect?.type == CCAction.PixelateOval ||
            selectedVideoEffect?.type == CCAction.PixelateScreen ||
            selectedVideoEffect?.type == CCAction.PixelateRect
          "
        >
          <div class="slider-label-container">
            <label class="slider-name-label">Pixels density</label>
            <label class="slider-value-label">{{
              selectedSegment?.instructions?.density
            }}</label>
          </div>
          <mat-slider min="1" max="100" step="1" discrete>
            <input
              (valueChange)="onDensityChange($event)"
              matSliderThumb
              [value]="selectedSegment?.instructions?.density"
            />
          </mat-slider>
        </div>
        <div
          [hidden]="
            !selectedSegment ||
            selectedSegment.isApproved ||
            !selectedVideoEffect ||
            selectedVideoEffect.type == 0 ||
            isVideoScreenEffect()
          "
        >
          <div class="slider-label-container">
            <label class="slider-name-label">Scaling Factor</label>
            <label class="slider-value-label">{{
              selectedSegment?.instructions?.scaleFactor || "default"
            }}</label>
          </div>
          <mat-slider min="1.0" max="1.5" step="0.1" discrete>
            <input
              (valueChange)="onScalingFactorChange($event)"
              matSliderThumb
              [value]="selectedSegment?.instructions?.scaleFactor"
            />
          </mat-slider>
        </div>
      </div>
    </div>
  </div>
  <div class="container" #hideAudio>
    <div class="container-head">
      <span>audio</span>
      <div class="buttons">
        <div class="row" [class.disallow]="disableEverything">
          <evrideo-content-control-studio-action-button
            (buttonClicked)="HideAudioMenu() && buttonClicked(CCAction.Mute)"
            title="mute audio"
          >
            <img src="/assets/ccstudio/mute.png" />
          </evrideo-content-control-studio-action-button>
          <evrideo-content-control-studio-action-button
            (buttonClicked)="buttonClicked(CCAction.Beep)"
            (click)="!disableEverything && toggleShowHideAudioMenu()"
            title="beep sound"
          >
            <img
              style="width: 11px; height: 15px"
              src="/assets/ccstudio/music-note.png"
            />
          </evrideo-content-control-studio-action-button>
        </div>
      </div>
    </div>
    <div class="container-body">
      <div *ngIf="selectedSegment" class="adjustments">
        <div
          *ngIf="selectedSegment.action === CCAction.Beep"
          style="margin-top: 20px"
        >
          <div class="slider-label-container">
            <label class="slider-name-label">Beep frequency</label>
            <label class="slider-value-label"
              >{{ selectedSegment?.instructions?.beepFrequency }}Hz</label
            >
          </div>
          <mat-slider
            min="200"
            max="2000"
            step="1"
            discrete
            [displayWith]="formatBeepFrequencyLabel"
          >
            <input
              (valueChange)="onBeepFrequencyChange($event)"
              matSliderThumb
              [value]="selectedSegment?.instructions?.beepFrequency"
            />
          </mat-slider>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="container-head">
      <span>subtitles</span>
      <div class="buttons">
        <div
          class="row"
          [class.disallow]="disableEverything || !isSubtitlesAvailable"
        >
          <evrideo-content-control-studio-action-button
            (buttonClicked)="
              isSubtitlesAvailable && buttonClicked(CCAction.EditSubtitles)
            "
            title="edit subtitles"
          >
            <img src="/assets/ccstudio/speakers-note.png" />
          </evrideo-content-control-studio-action-button>
          <evrideo-content-control-studio-action-button
            (buttonClicked)="
              isSubtitlesAvailable && buttonClicked(CCAction.RemoveSubtitles)
            "
            title="hide subtitles"
          >
            <img src="/assets/ccstudio/speakers-note-off.png" />
          </evrideo-content-control-studio-action-button>
        </div>
      </div>
    </div>
    <div class="container-body"></div>
  </div>
  <div class="container">
    <div class="container-head">
      <span>cut</span>
      <div class="buttons">
        <div class="row" [class.disallow]="!allowCut || disableEverything">
          <evrideo-content-control-studio-action-button
            (buttonClicked)="allowCut && buttonClicked(CCAction.Cut)"
            title="cut"
          >
            <img src="/assets/ccstudio/trash.png" />
          </evrideo-content-control-studio-action-button>
        </div>
      </div>
    </div>
    <div class="container-body"></div>
  </div>
  <div class="container">
    <div class="container-head">
      <span>approve</span>
      <div class="buttons">
        <div class="row" [class.disallow]="disableEverything">
          <evrideo-content-control-studio-action-button
            (buttonClicked)="buttonClicked(CCAction.Approve)"
            title="approve"
          >
            <img src="/assets/ccstudio/approve.png" />
          </evrideo-content-control-studio-action-button>
        </div>
      </div>
    </div>
    <div class="container-body"></div>
  </div>
  <!--<div class="container" *ngIf="isLive">
    <div class="container-head">
      <span>detect clip</span>
      <div class="buttons">
        <div class="row" [class.disallow]="disableEverything">
          <evrideo-content-control-studio-action-button
            (buttonClicked)="buttonClicked($event)"
          >
            <img src="/assets/ccstudio/flag.png" title="detect clip" />
          </evrideo-content-control-studio-action-button>
        </div>
      </div>
    </div>
    <div class="container-body"></div>
  </div>
  <div class="container" *ngIf="isLive">
    <div class="container-head">
      <span>show start/end</span>
      <div class="buttons">
        <div class="row" [class.disallow]="disableEverything">
          <evrideo-content-control-studio-action-button
            (buttonClicked)="buttonClicked($event)"
          >
            <img src="/assets/ccstudio/start-point.png" title="start point" />
          </evrideo-content-control-studio-action-button>
          <evrideo-content-control-studio-action-button
            (buttonClicked)="buttonClicked()"
          >
            <img src="/assets/ccstudio/end-point.png" title="end point" />
          </evrideo-content-control-studio-action-button>
        </div>
      </div>
    </div>
    <div class="container-body"></div>
  </div>-->
</ng-template>
<ng-template #videoClipsBody>
  <div class="video-clips-search">
    <input
      type="text"
      [ngModel]="videoClipsSearchQuery"
      (ngModelChange)="onSearchQueryChange($event)"
      placeholder="Search clips..."
    />
    <div class="video-clips-search-icon">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.5 3a5.5 5.5 0 1 0 3.476 9.79l3.867 3.867a.75.75 0 0 0 1.06-1.06l-3.867-3.868A5.5 5.5 0 0 0 8.5 3ZM4.5 8.5a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z"
          fill="rgba(0,0,0,0.35)"
        />
      </svg>
    </div>
  </div>
  <div class="video-clips-list">
    <div
      class="video-clip-item"
      *ngFor="let clip of filteredVideoClips"
    >
      <div class="video-clip-thumbnail">
        <img [src]="clip.thumbnailUrl" [alt]="clip.name" />
      </div>
      <div class="video-clip-details">
        <span class="video-clip-name">{{ clip.name }}</span>
        <span class="video-clip-duration">{{ clip.duration }}</span>
      </div>
      <button
        class="video-clip-add"
        (click)="onVideoClipAdd.emit(clip)"
        title="Add clip"
      >+</button>
    </div>
  </div>
</ng-template>
